import React,{Fragment} from 'react'
import {NavLink} from 'react-router-dom';
import { Menu } from 'semantic-ui-react'
import Search from './Search';
import { useMediaQuery,createMuiTheme } from '@material-ui/core';
import LongMenu from './Menu';
import {withRouter} from 'react-router';

const theme = createMuiTheme({
  breakpoints : {
    xs : 300,
    sm : 500,
    md : 650,
    lg : 900,
    xl : 1000
  }
})


function Navigation (props){

  const isMatch = useMediaQuery(theme.breakpoints.between("lg","xl"))
  const isMatch1 = useMediaQuery(theme.breakpoints.between("sm","md"))
    
  let route = props.history.location.pathname
  

 
  const navs = (
    <Fragment>    
    <Menu.Item 
    active={route==="/"}
    >
    <NavLink to="/">Home</NavLink>
    </Menu.Item>
    <Menu.Item 
    active={route==="/services"}
    >
    <NavLink  to="/services">Our Services</NavLink>
    </Menu.Item>
    <Menu.Item
    active={route==="/register"}
    >
    <NavLink to="/register">Register</NavLink>
    </Menu.Item>
    
    <Menu.Menu position='right'>
      <Menu.Item>
      <Search />
      </Menu.Item>
    </Menu.Menu>
    </Fragment>
  )
    const respMenu = (
    <Fragment>

      <Menu.Item  style={{ backgroundColor : 'black' }}>
      <img src="../../cocentric.jpg" style={{width : '190px',height: '50px'}} alt=""/>
      </Menu.Item>
      <Menu.Menu position='right'>
      <Menu.Item >
        <Search />
      </Menu.Item>
      </Menu.Menu>
      <Menu.Menu>
      <Menu.Item >
        <LongMenu />
      </Menu.Item>
      </Menu.Menu>
      </Fragment>
    )
  return (  
      <div className="bg-dark">
      { (!isMatch) ? 
        !isMatch1 ? 
        <Menu inverted pointing color="black" widths="3" size="tiny" >
          {respMenu}
        </Menu>
        :
        <Menu inverted pointing color="black" widths="8" size="tiny" >
        <img src="../../cocentric.jpg" style={{width : '150px',height: '55px'}} alt=""/>
        <Menu.Item style={{ backgroundColor : 'black' }}></Menu.Item>
         
          {navs}
        </Menu> 
      :
      <Menu inverted pointing widths="6" color="black" size="tiny" >
      <img src="../../cocentric.jpg" style={{width : '200px',height: '55px'}} alt=""/>
          <Menu.Item style={{ backgroundColor : 'black' }}></Menu.Item>
         {navs}
      </Menu>
      
      }
  
      </div>
    )
  }

export default withRouter(Navigation)
